import request from './ajax'

const newsUrl = '/api/pay/'
// 获取线下支付订单列表
export const getShopOrderIndex = (data) => request(newsUrl + 'shop', 'post', { ...data })
export const getShopOrderCreatPay = (data) => request(newsUrl + 'creat-pay', 'post', { ...data })
